import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export const trackReviewCountOnPageImpression = (rootElement: HTMLElement) => {
    const trackedReviewCount = rootElement.getAttribute('data-tracked-review-count');
    if (trackedReviewCount == null) return;
    trackView({ review_ReviewCount: [trackedReviewCount] });
};
